import API from 'app/gamma/src/api';
import { Action, actionCreator } from '@trello/redux';

import { BoardResponse } from 'app/gamma/src/types/responses';
import { StandardThunkAction, Dispatch } from 'app/gamma/src/types';
import { CLOSED_BOARD_FIELDS } from './fields';

// Action types
export const LOAD_CLOSED_BOARDS_REQUEST = Symbol(
  'loaders/LOAD_CLOSED_BOARDS_REQUEST',
);
export const LOAD_CLOSED_BOARDS_SUCCESS = Symbol(
  'loaders/LOAD_CLOSED_BOARDS_SUCCESS',
);
export const LOAD_CLOSED_BOARDS_ERROR = Symbol(
  'loaders/LOAD_CLOSED_BOARDS_ERROR',
);

export type LoadClosedBoardsRequestAction = Action<
  typeof LOAD_CLOSED_BOARDS_REQUEST,
  null
>;
export type LoadClosedBoardsSuccessAction = Action<
  typeof LOAD_CLOSED_BOARDS_SUCCESS,
  BoardResponse[]
>;
export type LoadClosedBoardsErrorAction = Action<
  typeof LOAD_CLOSED_BOARDS_ERROR,
  Error
>;

// Action creators
const loadClosedBoardsRequest = actionCreator<LoadClosedBoardsRequestAction>(
  LOAD_CLOSED_BOARDS_REQUEST,
);
export const loadClosedBoardsSuccess = actionCreator<LoadClosedBoardsSuccessAction>(
  LOAD_CLOSED_BOARDS_SUCCESS,
);
const loadClosedBoardsError = actionCreator<LoadClosedBoardsErrorAction>(
  LOAD_CLOSED_BOARDS_ERROR,
);

export const loadClosedBoards = (): StandardThunkAction => {
  return (dispatch: Dispatch) => {
    dispatch(loadClosedBoardsRequest());

    return API.client.rest
      .get<BoardResponse[]>('members/me/boards', {
        query: {
          filter: 'closed',
          fields: CLOSED_BOARD_FIELDS,
        },
      })
      .then((boards) => {
        dispatch(loadClosedBoardsSuccess(boards));
      })
      .catch((err) => {
        dispatch(loadClosedBoardsError(err));
      });
  };
};
